import { _ } from "js/vendor";
import React, { Component } from "reactn";
import linkDS, { LinkType } from "js/react/views/PresentationSettings/dataservices/LinkDataService";
import {
    flattenPresentationLinkEmails,
    InviteInputWithGContacts
} from "js/react/components/EmailInput/InviteInput";
import { BeautifulDialog, DialogContent, ShowDialog, ShowErrorDialog } from "js/react/components/Dialogs/BaseDialog";
import { FlexSpacer, Gap10, Gap20 } from "js/react/components/Gap";
import Spinner from "js/react/components/Spinner";
import { app } from "js/namespaces";
import { trackActivity } from "js/core/utilities/utilities";
import { InvitePreviewEmailDialog } from "./ShareDialog";
import TextArea from "js/react/components/TextArea";
import { DialogTitle, DialogActions, Button } from "@material-ui/core";
import { ToggleAllowCommenting } from "../components/ToggleAllowCommenting";
import LinkExpiration from "js/react/components/LinkExpiration";

export default class CreateInviteDialog extends Component {
    state = {
        showSpinner: false,
        customMessage: "",
        isInviteDisabled: true,
        emails: [],
        linkExpiresAt: null,
        allowCommenting: false,
    };

    static get type() {
        return "CreateInvite";
    }

    handleDuplicatedEmails = (flattenedEmailsObj, duplicatedEmails) => {
        const { emails } = this.state;
        this.setState({
            emails: emails.filter(tag => (tag.email ? !flattenedEmailsObj[tag.email] : !flattenedEmailsObj[tag])),
        });

        const errorMessage = "The following users already have access to this presentation: ";
        ShowErrorDialog({
            error: "Oops!",
            message: errorMessage.concat(duplicatedEmails.join(", "))
        });
    };

    handleAccept = async () => {
        const {
            emails,
            customMessage,
            linkExpiresAt,
            allowCommenting,
        } = this.state;
        const lowercaseEmails = emails.map(email => email.email || email).map(email => email.toLowerCase());

        const presentation = this.global.presentation;
        const links = _.filter(presentation.links.models, link => link.get("type") == LinkType.INVITE);
        const flattenedEmailsObj = flattenPresentationLinkEmails(links);
        const duplicatedEmails = lowercaseEmails.filter(email => flattenedEmailsObj[email]);
        if (duplicatedEmails.length) {
            this.handleDuplicatedEmails(flattenedEmailsObj, duplicatedEmails);
            return;
        }

        try {
            this.setState({ showSpinner: true });

            const linkIds = [];
            for (let email of lowercaseEmails) {
                const link = await linkDS.createInviteLink(
                    this.props.presentation,
                    email,
                    customMessage,
                    linkExpiresAt,
                    allowCommenting
                );
                await linkDS.saveLink(this.props.presentation, link);
                linkIds.push(link.id);
            }

            this.setGlobal({
                alertMessage: "Invites were sent"
            });

            const props = {
                presentation_id: this.props.presentation.id,
                link_ids: linkIds,
                is_new: true,
                type: "email",
                sender_email: app.user.getEmail(),
                recipient_emails: emails,
                workspace_id: this.props.presentation.getWorkspaceId()
            };
            trackActivity("Sharing", "EmailLink", null, null, props, { audit: true });
        } catch (err) {
            ShowErrorDialog({
                error: "Error while sharing",
                message: err.message
            });
            console.error(err);
        } finally {
            this.props.closeDialog();
            this.props.callback();
        }
    };

    handleUpdateLinkExpiration = linkExpiration => {
        this.setState(linkExpiration);
    }

    handleInputChange = (emails, isInviteDisabled) => {
        this.setState({ emails, isInviteDisabled });
    }

    handleChangeCustomMessage = customMessage => {
        this.setState({
            customMessage
        });
    };

    handlePreviewEmail = async () => {
        ShowDialog(InvitePreviewEmailDialog, {
            presentation: this.props.presentation,
            customMessage: this.state.customMessage
        });
    };

    toggleAllowCommenting = event => {
        const allowCommenting = !this.state.allowCommenting;
        this.setState({ allowCommenting });
        this.forceUpdate();
    }

    render() {
        const {
            showSpinner,
            customMessage,
            isInviteDisabled,
            emails,
            linkExpiresAt,
            linkHasExpired,
            linkShouldExpire,
            allowCommenting,
        } = this.state;
        const { presentation } = this.props;
        const disabled = isInviteDisabled || (linkShouldExpire && linkHasExpired);

        return (
            <BeautifulDialog
                maxWidth="md"
                closeDialog={this.props.closeDialog}
            >
                {showSpinner && <Spinner />}
                <DialogTitle>
                    Invite People to View this Presentation
                </DialogTitle>
                <DialogContent>
                    <h3>
                        We’ll send each person an email with an individual link to view this presentation.
                        Pro users can track engagement with comments and viewer analytics.
                    </h3>
                    <Gap10 />
                    <InviteInputWithGContacts
                        onInputChange={this.handleInputChange}
                        tags={emails}
                        showGoogleContacts={false} />
                    <Gap10/>
                    <TextArea
                        isVisible
                        text={customMessage}
                        onChange={customMessage => this.handleChangeCustomMessage(customMessage) }
                        placeholder="Add a note..."
                    />

                    <Gap20 />
                    <ToggleAllowCommenting
                        allowCommenting={allowCommenting}
                        onToggle={this.toggleAllowCommenting}
                    />
                    <LinkExpiration
                        expiresAt={linkExpiresAt}
                        onUpdate={this.handleUpdateLinkExpiration}
                        presentation={presentation}
                        stacked
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handlePreviewEmail}>Preview Email</Button>
                    <FlexSpacer/>
                    <Button onClick={this.props.closeDialog}>
                        Cancel
                    </Button>
                    <Button disabled={disabled} onClick={this.handleAccept} color="primary">
                        Send Email
                    </Button>
                </DialogActions>
            </BeautifulDialog>
        );
    }
}
